"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalTopAreaStyles = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _hooks = require("../../hooks");
var _TopAreaBlock = require("../TopAreaBlock");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve -- styles only file */

const TOP_NAV_HEIGHT_ANIMATION = '--top-nav-height-animation';
const TOP_AREA_APP_ROOT_ELEMENT_ID = 'online-top-area-root';
const GlobalTopAreaStyles = () => {
  const styles = (0, _react.useMemo)(() => ({
    [`.${_hooks.TopNavClassName.default}`]: {
      [TOP_NAV_HEIGHT_ANIMATION]: '0.3s ease-in-out',
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.mobile}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_INNER_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.withTopAreaBanner}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.searchInputVisible}.${_hooks.TopNavClassName.mobile}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_SEARCH_INPUT_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_SEARCH_INPUT_INNER_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.withTopAreaBanner}.${_hooks.TopNavClassName.searchInputVisible}.${_hooks.TopNavClassName.mobile}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_INNER_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.withTopAreaBanner}.${_hooks.TopNavClassName.mobile}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_TOP_AREA_BANNER_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.MOBILE_WITH_TOP_AREA_BANNER_INNER_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.withTopAreaNavigation}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_WITH_TOP_AREA_NAVIGATION_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_HEIGHT}px`
    },
    [`.${_hooks.TopNavClassName.withTopAreaBanner}.${_hooks.TopNavClassName.withTopAreaNavigation}`]: {
      [_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_WITH_TOP_AREA_BANNER_AND_NAVIGATION_HEIGHT}px`,
      [_presentationUtils.TOP_NAV_INNER_HEIGHT_CSS_VARIABLE]: `${_presentationUtils.DESKTOP_HEIGHT}px`
    },
    [`.${_presentationUtils.TOP_NAV_NO_SCROLL}`]: {
      overflow: 'hidden'
    },
    [`#${TOP_AREA_APP_ROOT_ELEMENT_ID}`]: {
      height: 'unset'
    },
    [`#${_TopAreaBlock.TOP_AREA_ID}`]: {
      height: `var(${_presentationUtils.TOP_NAV_HEIGHT_CSS_VARIABLE})`,
      transition: `height var(${TOP_NAV_HEIGHT_ANIMATION})`
    }
  }), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.GlobalStyles, {
    styles: styles
  });
};
exports.GlobalTopAreaStyles = GlobalTopAreaStyles;
